require('angular/libs/avant/interceptors');
require('angular/libs/avant/customer_applications/factories/requestTimestamp.coffee');
